import React from 'react';
import Image from '../../../../../components/image/image';
import HtmlBlock from '../../../../../components/htmlBlock/htmlBlock';
import Link from '../../../../../components/link/link';
import {productCard, productCard__img, productCard__content} from './productCard.module.scss';

const ProductCard = ({data, className, ...other}) => {
    const {title, seo, featuredImage, ...slug} = data;
    return (
      <article className={`${productCard} ${className || ''}`} {...other}>
        {
          (seo?.image || featuredImage) &&
          <Link icon={false} className={productCard__img} data={slug}>
            <Image data={seo?.image || featuredImage} />
          </Link>
        }
        <div className={productCard__content}>
          {
            title && <Link icon={false} className="" data={slug}><HtmlBlock className="h4" tag='h2'>{title}</HtmlBlock></Link>
          }
          {
            seo?.description && <p className="body--large">{seo.description}</p>
          }
        </div>
      </article>
    );
};

export default ProductCard;
